module.exports = __webpack_public_path__ + "static/doulakreis-logo-836221973db7d797504d882f10a44927.png";